import styled from 'styled-components';

import { rem, mediaUp } from 'approot/shared/style';
import {
  ActivityBuilderSlideItem,
  ActivityBuilderSlideItemSubSlide,
} from 'approot/activity-builder/activity-builder-slides.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import {
  DRAFT_BANNER_HEIGHT_SMALL,
  DRAFT_BANNER_HEIGHT_LARGE,
} from './activity-builder-draft.style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';

export const SLIDES_WIDTH = 180;

export const ActivityBuilderDraftSlidesNav = styled.nav`
  bottom: 0;
  background-color: ${grey1};
  left: 0;
  overflow: auto;
  overflow-x: hidden;
  position: fixed;
  top: ${rem(LAYOUT_HEADER_HEIGHT + DRAFT_BANNER_HEIGHT_SMALL)};
  width: ${rem(SLIDES_WIDTH)};

  ${mediaUp.sm`
    top: ${rem(LAYOUT_HEADER_HEIGHT + DRAFT_BANNER_HEIGHT_LARGE)};
  `}
`;

export const ActivityBuilderDraftSlideItem = styled(ActivityBuilderSlideItem)`
  margin-bottom: ${rem(spacing16)};
`;

export const ActivityBuilderDraftSubSlideItem = styled(
  ActivityBuilderSlideItemSubSlide
)`
  margin-bottom: ${rem(spacing16)};
`;

export const ActivityBuilderDraftSubSlideUl = styled(BoxList)`
  position: relative;

  &:before {
    content: '';
    background-color: ${grey4};
    border-radius: ${rem(4)};
    position: absolute;
    top: 0;
    bottom: 0;
    left: ${rem(34)};
    width: ${rem(4)};
  }
`;
